<template lang="jade">
  .col-md-3.col-md-offset-9.well
    form(v-on:submit.prevent="submit()")
      label Email
        input(type="text" name="email" v-model="username")
      label Senha
        input(type="password" name="password" v-model="password")
      input(type="submit" value="Entrar")
</template>

<script>
import { handleRequest } from '../services'
import Cookies from 'js-cookie'
import { mapActions } from 'vuex'

export default {
  created () {
    if (this.$store.state.authorization) {
      this.$router.push('/sheet-checker')
    }
  },
  computed: {
    username: {
      get () {
        return this.$store.getters.getLoginUsername
      },
      set (value) {
        this.$store.dispatch('username', value)
      }
    },
    password: {
      get () {
        return this.$store.getters.getLoginPassword
      },
      set (value) {
        this.$store.dispatch('password', value)
      }
    }
  },
  methods: {
    ...mapActions([
      'setScreenLoginInfo',
      'setAuthorization'
    ]),
    async submit () {
      let data = {
        username: this.$store.getters.getLoginUsername,
        password: this.$store.getters.getLoginPassword
      }

      const response = await handleRequest.post('auth', data)

      const token = 'Bearer ' + response.data.access_token
      Cookies.set('Authorization', token)
      this.setAuthorization(token)
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?4ce5f686